import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import CustomTooltip from "../Buttons/CustomTooltip";

function LeftSidebar({ setActiveTab, activeTab, isCollapsed, setIsCollapsed }) {
  const [isMigrationExpanded, setIsMigrationExpanded] = useState(false);
  const [isSourceProfilerExpanded, setIsSourceProfilerExpanded] =
    useState(false);

  const location = useLocation();
  const { state } = useAuth();
  const navigate = useNavigate();

  // Initialize states based on current route
  // Initialize states based on current route
  useEffect(() => {
    const isOnMigrationPath = location.pathname.startsWith("/migration");
    const isOnReportsPath = location.pathname.includes("/viewReportspage");
    const isOnProfilePath = location.pathname === "/profile";
    const isOnEditProfilePath = location.pathname === "/edit-profile";
    const isOnDraftPath = location.pathname === "/migration/draft_jobs";
    const isOnDBMigrationPath = location.pathname === "/listmigration";
    // const isOnSettingsPath = location.pathname === "/settings";
    const isOnSettingsnewPath = location.pathname === "/settings";
    const isOnHomePath = location.pathname === "/home";
    const isOnSourceProfilerPath = location.pathname === "/sourceprofiler";
    const isOnDraftSourcesPath =
      location.pathname === "/sourceprofiler/draft_jobs";
    const isOnDeletedSourcesPath =
      location.pathname === "/sourceprofiler/deleted_sources";

    // Reset all expansions when on home
    if (isOnHomePath) {
      setIsMigrationExpanded(false);
      setIsSourceProfilerExpanded(false);
      setActiveTab("#home");
      localStorage.setItem("activeTab", "#home");
      return;
    }

    if (isOnProfilePath || isOnEditProfilePath) {
      setIsMigrationExpanded(false);
      setIsSourceProfilerExpanded(false);
      setActiveTab("#profile");
      localStorage.setItem("activeTab", "#profile");
      return;
    }

    if (isOnSettingsnewPath) {
      setActiveTab("#settings");
      localStorage.setItem("activeTab", "#settings");
      setIsMigrationExpanded(false);
      setIsSourceProfilerExpanded(false);
      return;
    }

    // if (isOnSettingsPath) {
    //   setActiveTab("#settings");
    //   localStorage.setItem("activeTab", "#settings");
    //   setIsMigrationExpanded(false);
    //   setIsSourceProfilerExpanded(false);
    //   return;
    // }

    // Handle Source Profiler paths
    if (
      isOnSourceProfilerPath ||
      isOnDraftSourcesPath ||
      isOnDeletedSourcesPath
    ) {
      setActiveTab("#sourceprofiler");
      localStorage.setItem("activeTab", "#sourceprofiler");
      setIsSourceProfilerExpanded(true);
      setIsMigrationExpanded(false);
      return;
    }

    // Handle Migration paths (including draft)
    if (isOnMigrationPath || isOnReportsPath || isOnDraftPath) {
      setIsMigrationExpanded(true);
      setIsSourceProfilerExpanded(false);
      setActiveTab("#migjob");
      localStorage.setItem("activeTab", "#migjob");
    } else if (isOnDBMigrationPath) {
      setActiveTab("#dbmigration-list");
      localStorage.setItem("activeTab", "#dbmigration-list");
    }
  }, [location.pathname, setActiveTab]);


// Add this helper component inside LeftSidebar
const SidebarTooltip = ({ text, children, placement = "right" }) => {
  if (!isCollapsed) return children;

  return (
    <CustomTooltip
      content={text}
      placement={placement}
      delay={{ show: 300, hide: 100 }}
    >
      <div style={{ display: 'inline-block', width: '100%' }}>
        {children}
      </div>
    </CustomTooltip>
  );
};

  const handleChevronClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setActiveTab("#migjob");
    localStorage.setItem("activeTab", "#migjob");
    navigate("/migration");
    setIsMigrationExpanded(true);
  };

  const handleMigrationTabClick = (e) => {
    if (e.target.classList.contains("fa-chevron")) {
      e.preventDefault();
    }

    setActiveTab("#migjob");
    localStorage.setItem("activeTab", "#migjob");

    if (isCollapsed) {
      setIsCollapsed(false);
      setIsMigrationExpanded(true);
    } else {
      setIsMigrationExpanded((prev) => !prev);
    }
  };

  const handleSourceProfilerClick = (e) => {
    if (e.target.classList.contains("fa-chevron")) {
      e.preventDefault();
    }

    setActiveTab("#sourceprofiler");
    localStorage.setItem("activeTab", "#sourceprofiler");
    navigate("/sourceprofiler");

    if (isCollapsed) {
      setIsCollapsed(false);
      setIsSourceProfilerExpanded(true);
    } else {
      setIsSourceProfilerExpanded((prev) => !prev);
    }
  };

  // Check active states
  // const isOnMigrationPage = location.pathname === "/migration";
  // const isOnDeletedJobsPage = location.pathname === "/migration/deleted_jobs";
  // const isOnReportsPage = location.pathname.includes("/viewReportspage");
  // const isOnDraftJobsPage = location.pathname === "/migration/draft_jobs";
  // const isOnProfilePage = location.pathname === "/profile" || location.pathname === "/edit-profile";
  // const isOnDBMigrationPage = location.pathname === "/listmigration";
  // const isParentMigrationActive = isOnMigrationPage || isOnDeletedJobsPage || isOnReportsPage || isOnDraftJobsPage;
  // const isOnSourceProfilerPage = location.pathname === "/sourceprofiler";
  // const isOnDeletedSourcesPath = location.pathname === "/sourceprofiler/deleted_sources";
  // Check active states
  const isOnMigrationPage = location.pathname === "/migration";
  const isOnDeletedJobsPage = location.pathname === "/migration/deleted_jobs";
  const isOnDraftJobsPage = location.pathname === "/migration/draft_jobs"; // Add this
  const isOnReportsPage = location.pathname.includes("/viewReportspage");
  const isOnProfilePage =
    location.pathname === "/profile" || location.pathname === "/edit-profile";
  const isOnDBMigrationPage = location.pathname === "/listmigration";
  const isParentMigrationActive =
    isOnMigrationPage ||
    isOnDeletedJobsPage ||
    isOnReportsPage ||
    isOnDraftJobsPage; // Include draft

  // For Source Profiler
  const isOnSourceProfilerPage = location.pathname === "/sourceprofiler";
  const isOnDraftSourcesPage =
    location.pathname === "/sourceprofiler/draft_jobs"; // Add this
  const isOnDeletedSourcesPath =
    location.pathname === "/sourceprofiler/deleted_sources";
  const isParentSourceProfilerActive =
    isOnSourceProfilerPage || isOnDraftSourcesPage || isOnDeletedSourcesPath; // Include draft

  return (
    <div
      className={`vertical-menu bg-primary font-family-inter ${
        isCollapsed ? "" : "show"
      }`}
    >
      <div className="h-100 ver-w">
        <div className="d-grid align-content-between height-calc54px">
          {/* Main sidebar content */}
          <div id="sidebar-menu" data-simplebar className="side-menu">
            {/* Collapse button */}
            <div
              onClick={() => {
                setIsCollapsed(true);
                setIsMigrationExpanded(false);
              }}
              className="ver-col"
              id="vertical-menu-btn"
            >
              <i className="fas fa-chevron-left font-size-10"></i>
            </div>

            {/* Menu items */}
            <ul className="list-unstyled tabs mb-1">
              {/* Home menu item */}
            {/* Home menu item */}
<SidebarTooltip text="Home">
  <li
    className={`${
      activeTab === "#home" ? "active mm-active" : ""
    } p-2 pt-1 pb-1 d-flex menu`}
    onClick={() => {
      setActiveTab("#home");
      localStorage.setItem("activeTab", "#home");
      setIsCollapsed(false);
      setIsMigrationExpanded(false);
      setIsSourceProfilerExpanded(false);
    }}
  >
    <Link
      to="/home"
      className="waves-effect w-100 ps-3 pe-3 pt-2 pb-2"
    >
      <p className="mb-0 font-size-12 d-flex align-item-center">
        <i className="new-home font-size-18"></i>
        <span className="ps-2 font-size-12">Home</span>
      </p>
    </Link>
  </li>
</SidebarTooltip>

               {/* Source Profiler menu item */}
               <SidebarTooltip text="Source Profiler">
              <li
                className={`${
                  isParentSourceProfilerActive ? "active mm-active" : ""
                } p-2 pt-1 pb-1 menu`}
              >
                <div className="d-flex flex-column w-100">
                  <div className="d-flex align-items-center w-100">
                    <Link
                      to="/sourceprofiler"
                      className="waves-effect w-100 ps-3 pe-3 pt-2 pb-2 d-flex align-items-center justify-content-between"
                      onClick={handleSourceProfilerClick}
                    >
                      <div className="d-flex align-items-center">
                        <i className="sr-source-se font-size-16 "></i>

                        <span className="ps-2 font-size-12">
                          Source Profiler
                        </span>
                      </div>
                      {!isCollapsed && (
                        <i
                          className={`fas fa-chevron-${
                            isSourceProfilerExpanded ? "down" : "right"
                          } font-size-10`}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setActiveTab("#sourceprofiler");
                            localStorage.setItem(
                              "activeTab",
                              "#sourceprofiler"
                            );
                            navigate("/sourceprofiler");
                            setIsSourceProfilerExpanded(true);
                          }}
                        ></i>
                      )}
                    </Link>
                  </div>

                  {isSourceProfilerExpanded && !isCollapsed && (
                    <ul
                      className="list-unstyled pt-2 submenu-items"
                      style={{ paddingLeft: "36px" }}
                    >
                      <li className="mb-2">
                        <Link
                          to="/sourceprofiler"
                          className={`font-size-12 d-block ps-2 pe-2 pt-1 pb-1 rounded ${
                            location.pathname === "/sourceprofiler" ||
                            location.pathname === "/sourceprofiler/draft_jobs"
                              ? "submenu-item-active text-custom-white"
                              : "text-custom-grey"
                          }`}
                          onClick={() => {
                            setActiveTab("#sourceprofiler-list");
                            localStorage.setItem(
                              "activeTab",
                              "#sourceprofiler-list"
                            );
                          }}
                        >
                          Profiler list
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link
                          to="/sourceprofiler/deleted_sources"
                          className={`font-size-12 d-block ps-2 pe-2 pt-1 pb-1 rounded ${
                            location.pathname ===
                            "/sourceprofiler/deleted_sources"
                              ? "submenu-item-active text-custom-white"
                              : "text-custom-grey"
                          }`}
                          onClick={() => {
                            setActiveTab("#sourceprofiler-deleted");
                            localStorage.setItem(
                              "activeTab",
                              "#sourceprofiler-deleted"
                            );
                          }}
                        >
                          Deleted Sources
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              </SidebarTooltip>

              {/* DBMigration - now without dropdown */}
              <SidebarTooltip text="Data Migration">
              <li
                className={`${
                  isOnDBMigrationPage ? "active mm-active" : ""
                } p-2 pt-1 pb-1 d-flex menu`}
                onClick={() => {
                  setActiveTab("#dbmigration-list");
                  localStorage.setItem("activeTab", "#dbmigration-list");
                  setIsCollapsed(false);
                  setIsMigrationExpanded(false);
                     setIsSourceProfilerExpanded(false);
                }}
              >
                <Link
                  to="/listmigration"
                  className="waves-effect w-100 ps-3 pe-3 pt-2 pb-2"
                >
                  <p className="mb-0 font-size-12 d-flex align-item-center">
                    <i className="ri-database-2-line font-size-18"></i>
                    <span className="ps-2 font-size-12">Data Migration</span>
                  </p>
                </Link>
              </li>
              </SidebarTooltip>

              {/* Migration Jobs menu item */}
                <SidebarTooltip text="Code Conversion">
              <li
                className={`${
                  isParentMigrationActive ? "active mm-active" : ""
                } p-2 pt-1 pb-1 menu`}
              >
                <div className="d-flex flex-column w-100">
                  <div className="d-flex align-items-center w-100">
                    <Link
                      to="/migration"
                      className="waves-effect w-100 ps-3 pe-3 pt-2 pb-2 d-flex align-items-center justify-content-between"
                      onClick={handleMigrationTabClick}
                    >
                      <div className="d-flex align-items-center">
                        <i className="ri-code-line font-size-18"></i>
                        <span className="ps-2 font-size-12">
                          Code Conversion
                        </span>
                      </div>
                      {!isCollapsed && (
                        <i
                          className={`fas fa-chevron-${
                            isMigrationExpanded ? "down" : "right"
                          } font-size-10`}
                          onClick={handleChevronClick}
                        ></i>
                      )}
                    </Link>
                  </div>

                  {isMigrationExpanded && !isCollapsed && (
                    <ul
                      className="list-unstyled pt-2 submenu-items"
                      style={{ paddingLeft: "36px" }}
                    >
                      <li className="mb-2">
                        <Link
                          to="/migration"
                          className={`font-size-12 d-block ps-2 pe-2 pt-1 pb-1 rounded ${
                            location.pathname === "/migration" ||
                            location.pathname === "/migration/draft_jobs"
                              ? "submenu-item-active text-custom-white"
                              : "text-custom-grey"
                          }`}
                          onClick={() => {
                            setActiveTab("#migjob-list");
                            localStorage.setItem("activeTab", "#migjob-list");
                          }}
                        >
                          Run Conversions
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link
                          to="/migration/deleted_jobs"
                          className={`font-size-12 d-block ps-2 pe-2 pt-1 pb-1 rounded ${
                            isOnDeletedJobsPage
                              ? "submenu-item-active text-custom-white"
                              : "text-custom-grey"
                          }`}
                          onClick={() => {
                            setActiveTab("#migjob-deleted");
                            localStorage.setItem(
                              "activeTab",
                              "#migjob-deleted"
                            );
                          }}
                        >
                          Deleted Conversions
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              </SidebarTooltip>
             
            </ul>
          </div>

          {/* Bottom menu section */}

          <div className="bottom-menu">
            {/* Settings Start Here */}
            {/* {state?.user?.role === "admin" && ( */}
            <ul className="list-unstyled tabs mb-0">
             <SidebarTooltip text="Settings">
      <li
        className={`${
          activeTab === "#settings" ? "active mm-active" : ""
        } p-2 pt-1 pb-1 menu`}
        onClick={() => {
          setActiveTab("#settings");
          setIsCollapsed(false);
          localStorage.setItem("activeTab", "#settings");
          setIsMigrationExpanded(false);
          localStorage.setItem("isCollapsed", "false");
        }}
      >
        <Link
          to="/settings"
          className="waves-effect w-100 ps-3 pe-3   d-flex align-items-center justify-content-between paddingcss"
          // REMOVE THESE BOOTSTRAP TOOLTIP ATTRIBUTES:
          // data-bs-toggle="tooltip"
          // data-bs-placement="right"
          // data-bs-original-title="Settings New"
        >
          <p className="mb-0 font-size-12 d-flex align-item-center">
            <i className="new-setting font-size-18 m-0 bottom-sidemenu-icon"></i>
            <span className="ps-2">Settings</span>
          </p>
        </Link>
      </li>
    </SidebarTooltip>
            </ul>
            {/* )} */}
            {/* Settings End Here */}
            <div className="logout pb-2">
                <SidebarTooltip text="DbShift v1.0">
              <a href="signin.html" className="d-flex justify-content-center">
                <i className="new-wizard"></i>
              </a>
              </SidebarTooltip>
            </div>
            <div className="d-flex px-3 pt-1 pb-2 justify-content-between align-items-center version">
                <SidebarTooltip text="DbShift">
              <p className="mb-0 font-size-12 ps-2 d-flex align-items-center text-sidemenu">
                <i className="new-wizard font-size-18 me-2 text-sidemenu"></i>
                DbShift
              </p>
              </SidebarTooltip>
              <p className="mb-0 font-size-12 text-sidemenu">v1.0</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeftSidebar;
